import * as React from 'react';
import { ModalProps } from 'antd/es/modal';
import { useState } from 'react';
import t from 'utils/translations';
import { ConfirmationModal } from 'components/pages/grouplistpage/actionmenu/DeleteGroupModal';
import styled from 'styled-components';
import theme from 'theme';
import { message } from 'antd';
import { apiRemoveAllCompaniesFromGroup } from 'api/groups';

const InfoText = styled.p`
    && {
        color: ${theme.colors.gray_dark};
        font-size: 14px;
        margin-left: 15px;
    }
`;

interface Props extends ModalProps {
    afterSuccess: () => void;
    groupId: string;
    groupName: string;
    closeModal: () => void;
    numberOfCompaniesInGroup: number;
}

function DeleteAllCompaniesFromGroup({
    afterSuccess,
    groupId,
    groupName,
    closeModal,
    numberOfCompaniesInGroup,
    visible
}: Props) {
    const [isLoading, setIsLoading] = useState(false);

    function handleCancel() {
        closeModal();
    }

    function handleOk() {
        setIsLoading(true);
        apiRemoveAllCompaniesFromGroup(groupId)
            .then(res => {
                if (res.status === 200) {
                    message.success(t('DELETE_ALL_COMPANIES_SUCCESS'));
                    setIsLoading(false);
                    afterSuccess();
                    closeModal();
                }
            })
            .catch(() => {
                message.error(t('DELETE_ALL_COMPANIES_FAIL'));
                setIsLoading(false);
            });
    }

    return (
        <ConfirmationModal
            cancelText={t('CANCEL_MODAL')}
            confirmLoading={isLoading}
            destroyOnClose={true}
            onCancel={() => handleCancel()}
            onOk={() => handleOk()}
            okText={t('DELETE_COMPANIES')}
            title={t('DELETE_ALL_COMPANIES_MODAL_TITLE')}
            visible={visible}
        >
            <>
                <p>{`${t('DELETE_ALL_COMPANIES_CONFIRM')} "${groupName}"?`}</p>
                <InfoText>{`${t(
                    'DELETE_ALL_COMPANIES_INFO_PART1'
                )} ${numberOfCompaniesInGroup} ${t(
                    'DELETE_ALL_COMPANIES_INFO_PART2'
                )}`}</InfoText>
            </>
        </ConfirmationModal>
    );
}

export default DeleteAllCompaniesFromGroup;
